var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"100vh"}},[_c('iframe',{attrs:{"src":`https://eankete.com/sr/anketa/${_vm.$route.params.q.qid}/ordera`,"width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }